import React from 'react';
import PortalFrame, { navigatePortal } from '../portal/PortalFrame';
import LandingNavigation from '../landing/LandingNavigation';
export { default as PageHero } from '../portal/PortalHero';

// Compatibility wrapper for existing public pages; callbacks stay with the caller.
export const PageHeader = ({ onBack, onLogin, onRegister }) => (
  <LandingNavigation onHome={onBack} onLogin={onLogin} onRegister={onRegister} navigateTo={navigatePortal} productTarget="/features" />
);

export default function PageLayout({ children, onBack, onLogin, onRegister }) {
  return <PortalFrame onBack={onBack} onLogin={onLogin} onRegister={onRegister}>{children}</PortalFrame>;
}
